<p>side-tray-visor-component works!</p>
